import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";
import * as React from "react";
import { sectionSpacing } from "./section-spacing";
import { headingFontFamily } from "../heading-font";
import { StoryCard } from "../story-card";

export interface UseCaseCard {
	id: string;
	eyebrow: string;
	icon: React.ReactElement;
	title: string;
	description: string;
	image: string;
	link: string;
}

export interface UseCasesContent {
	heading: string;
	subHeading: string;
	cards: UseCaseCard[];
}

export function UseCases({ content: useCases }: { content: UseCasesContent }) {
	return (
		<div>
			<Container
				maxWidth="lg"
				sx={{ py: sectionSpacing }}>
				<Stack spacing={8}>
					<Stack
						maxWidth="700px"
						spacing={2}
						sx={{ mx: "auto" }}>
						<Typography
							sx={{ textAlign: "center", fontFamily: headingFontFamily }}
							variant="h3">
							{useCases.heading}
						</Typography>
						<Typography
							variant="h6"
							color="text.secondary"
							sx={{ textAlign: "center" }}>
							{useCases.subHeading}
						</Typography>
					</Stack>
					<Grid
						container
						maxWidth="xl"
						spacing={{ xs: 3, md: 4 }}>
						{useCases.cards.map((card: UseCaseCard) => (
							<Grid
								key={card.id}
								size={{
									md: 6,
									sm: 6,
									xs: 12,
								}}>
								<StoryCard
									ctaLabel="Read the story"
									description={card.description}
									eyebrow={card.eyebrow}
									href={card.link}
									icon={card.icon}
									image={card.image}
									title={card.title}
								/>
							</Grid>
						))}
					</Grid>
				</Stack>
			</Container>
		</div>
	);
}
